<hr />
<div>
    <h4 class="d-inline-block">Help us by providing following details related to Petition filing</h4>
    <button type="button" *ngIf="disableFields" (click)="handleStatusEdit()"
        class="float-right im-btn im-btn-with-icon im-btn-outline-primary pull-right  button_whitebg">
        Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
    </button>
    <!-- <lib-step-status-update-component-library *ngIf="stepDetails" [visaType]="subTask?.taskTypeDetails?.visaType" [stepDetails]="stepDetails" type="EDIT">
    </lib-step-status-update-component-library> -->

</div>
<div class="shadow-sm border mt-4 p-3 bg-light rounded">
    <h5>1. Upload all related individual documents to petition filing. </h5>
    <!-- <label class="d-inline-block m-2 ml-3">File Type</label> -->
    <file-upload-library [fileUploadConfigurations]="otherDocumentsFileUploadConfigurations"></file-upload-library>
    <!-- <i140-file-upload style="width: 100%;" *ngIf="otherDocumentsFileUploadConfigurations" [fileUploadConfigurations]="otherDocumentsFileUploadConfigurations">
    </i140-file-upload> -->
</div>

<div class="shadow-sm border mt-4 p-3 bg-light rounded">
    <h5>2. Upload all receipts provided by USCIS during petition filing. </h5>

    <div class="row">
        <div class="col-3">
            <label class="d-inline-block ml-0 mt-2">Receipt Category</label>
        </div>
        <div class="col-3 pl-0">
            <label class="d-inline-block m-2 ml-3 required">Receipt Number</label>
        </div>
    </div>
    <div class="row">
        <div class="col-3">
            <p-dropdown [disabled]="disableFields" [options]="receiptCategoryList" class="filetype-dropdown"
                [(ngModel)]="selectedReceiptCategory" optionLabel="name" placeholder="Select">
                <ng-template let-item pTemplate="item">
                    <span>{{item.name}}</span>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-3">
            <input [disabled]="disableFields" type="text" pInputText id="receiptNumberid" name="receiptNumberid" [(ngModel)]="receiptNumber"   [pattern]="receiptNumberRegexp" required
            #receiptNumberid="ngModel" />
            <span class="invalid-message"
                            *ngIf="receiptNumberid.errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
  
             <span  class="invalid-message" *ngIf="receiptNumberid.errors?.pattern">{{ getGlobalErrorMessages("INVALID_FORMAT") }}</span>
       
        </div>
        <!-- <div >
                    <span class="invalid-message"
                            *ngIf="receiptNumberid.errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
  
             <span  class="invalid-message" *ngIf="receiptNumberid.errors?.pattern">{{ getGlobalErrorMessages("INVALID_FORMAT") }}</span>
        </div> -->
    </div>
    <div class="row pt-4">
        <div class="col-2">
            <label class="required">Receipt Date</label>
        </div>
        <div class="col-2">
            <label>Petition Filing Date</label>
        </div>
    </div>
    <div class="row">
        <div class="col-2">
            <p-calendar [disabled]="disableFields" name="receiptDate" [(ngModel)]="receiptDate" dateFormat="dd-mm-yy"
                [showIcon]="true"></p-calendar>
        </div>
        <div class="col-2">
            <p-calendar [disabled]="disableFields" name="filingDate" [maxDate]="receiptDate" [(ngModel)]="filingDate"
                dateFormat="dd-mm-yy" [showIcon]="true"></p-calendar>
        </div>
        <div class="row">
            <div class="col-5">
                  
                <p-fileUpload [disabled]="!receiptNumber || !receiptDate || disableFields"
                    #createReceiptUploader name="demo[]" mode="basic" chooseLabel="Upload" [auto]="true" customUpload="true"
                    accept=".pdf" (uploadHandler)="onReceiptUpload($event, createReceiptUploader)" showUploadButton="false"
                    chooseIcon="pi pi-upload" showCancelButton="false" maxFileSize="10485760">
                </p-fileUpload>
            </div>
            <div class="col-7">
                <small class="d-block">Max file size is 10MB</small>
                <small>PDF file type is allowed</small>
            </div>
        </div>
    </div>

    <div class="row mt-4 pl-3">
        <h6 class="mt-3"> Uploaded Receipts List</h6>
    </div>

    <div *ngIf="uploadedReceiptsList.length == 0" class="uploadDocumentListTable">
        <div class="p-datatable">
            <div class="p-datatable-thead">
                <tr class="d-block">
                    <th class="col-3 d-inline-flex">Receipt Category</th>
                    <th class="col-3 d-inline-flex">Receipt Number</th>
                    <th class="col-3 d-inline-flex">Receipt Date</th>
                    <th class="col-3 d-inline-flex"><span class="float-right pr-5">Action</span></th>
                </tr>
            </div>
            <div class="p-datatable-tbody">
                <tr class="d-block">
                    <td class="py-2 font-italic text-warning">No Receipts Uploaded Yet...</td>
                </tr>
            </div>
        </div>
    </div>

    <div *ngIf="uploadedReceiptsList.length > 0">
        <p-table [value]="uploadedReceiptsList" class="uploadDocumentListTable">
            <ng-template pTemplate="header">
                <tr>
                    <th>Receipt Category</th>
                    <th>Receipt Name</th>
                    <th>Receipt Date</th>
                    <th><span class="float-right pr-5">Action</span></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file>
                <tr>
                    <td>{{file.fileCategory.description}}</td>
                    <td>{{file.fileName}}.pdf</td>
                    <td>{{file.receiptDate | date:'dd-MMM-yyyy' }}</td>
                    <td>
                        <div class="float-right pr-3">
                            <div *ngIf="file.fileLocation">

                                <button pButton type="button" icon="pi pi-eye" pTooltip="View"
                                    [disabled]="!file.fileLocation" (click)="viewDocument(file.fileLocation)"
                                    class="p-button-text p-button-rounded"></button>
                                <button pButton type="button" icon="pi pi-download" pTooltip="Download"
                                    (click)="download(file)" class="p-button-text p-button-rounded"></button>

                                <button pButton type="button" icon="pi pi-trash" pTooltip="Delete"
                                    (click)="confirmDelete(file,'receipt')" [disabled]="disableFields"
                                    class="p-button-text p-button-rounded"></button>

                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>
    <div class="text-center">
        <button type="button" *ngIf="currentStatus == 'Filed' && uploadedReceiptsList?.length > 0 && !disableFields  && userType != 'Beneficiary'"
            iconPos="right" pButton icon="fa fa-exclamation-circle" (click)="changeStatus('COMPLETE');"
            label="Mark Complete" class="button_whitebg p-button-outlined"></button>
        <div *ngIf="currentStatus == 'COMPLETE'" class="d-inline-block">
            <img src="../../../../../assets/images/stepCompleteLabel.png" />
        </div>

        <button type="button" pButton *ngIf="currentStatus == 'Filed' && !disableFields  && userType == 'Beneficiary'"
            iconPos="right" label="Mark Submit" icon="fa fa-exclamation-circle" class="button_whitebg p-button-outlined"
            (click)="changeStatus('SUBMIT')">
        </button>
    </div>

    <p-confirmDialog header="Delete"></p-confirmDialog>